module.exports = __webpack_public_path__ + "static/media/LOGO_Blackbackground_512x512.51587d6f.png";